import React, { useState } from 'react';
import { Alert, Button, IconButton, Slide, Stack } from '@mui/material';
import { NewDialog, NewDialogActions, NewDialogContent, NewDialogTitle } from 'components';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

export default function CheckMessages({ title = 'لیست خطا', data = [] }) {
  const [open, setOpen] = useState(false);
  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);
  return (
    <>
      <IconButton size="small" color="warning" onClick={onOpen} sx={{ bgcolor: 'warning.lighter' }}>
        <WarningRoundedIcon fontSize="small" />
      </IconButton>
      <NewDialog label={title} open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={1} rowGap={1} bgcolor="background.paper">
            {data.map(({ text }, i) => (
              <Slide key={i} in={open} timeout={150 * (i + 1)}>
                <Alert severity="warning" key={i}>
                  {text}
                </Alert>
              </Slide>
            ))}
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button autoFocus size="medium" color="error" variant="contained" sx={{ minWidth: 80 }} onClick={onClose}>
            ثبت
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
